import { all, identity, isEmpty, isNil, not, pipe } from "ramda";

export const allTrue = all(identity);

export const notEmpty = value => not(isEmpty(value));

export const isBlank = value =>
  value === undefined || isNil(value) || isEmpty(value);

export const notBlank = value => not(isBlank(value));

export const daysBetween = pipe(
  (date1, date2) => date2.getTime() - date1.getTime(),
  difInTime => difInTime / (1000 * 3600 * 24)
);

const compareDates = (start, end) => {
  const ay = start.getFullYear();
  const by = end.getFullYear();
  if (ay !== by) return ay - by;

  const am = start.getMonth();
  const bm = end.getMonth();
  if (am !== bm) return am - bm;

  return start.getDate() - end.getDate();
};

// maxRange === months
export const validateDateRange = (start, end, maxRange = 6) => {
  const xMonthsLater = new Date(
    start.getFullYear(),
    start.getMonth() + maxRange,
    start.getDate()
  );
  return compareDates(start, end) !== 1 && end <= xMonthsLater;
};
